import type { z } from 'zod';

import type { locationProfilesFiltersSchema, locationProfilesRouteQuerySchema } from './schemas';

// TODO: Move somewhero elso
export const SORT_DIRECTION = ['ASC', 'DESC'] as const;
export type SortDirection = (typeof SORT_DIRECTION)[number];

export const AZURE_STORAGE_ENVIRONMENTS = [
  'AzurePublicCloud',
  'AzureChinaCloud',
  'AzureUSGovernmentCloud',
] as const;
export type AzureStorageEnvironment = (typeof AZURE_STORAGE_ENVIRONMENTS)[number];

export const STORAGE_PROVIDERS = [
  'S3',
  'AZ',
  'GCS',
  'VBR',
  'FileStore',
  'GenericS3',
  'VeeamVault', // Deprecated; equivalent to VeeamVaultAzure
  'VeeamVaultAzure',
  'VeeamVaultAWS',
] as const;
export type StorageProvider = (typeof STORAGE_PROVIDERS)[number];

export const VALIDATION_STATUS_FILTERS = ['Success', 'Failed', 'Unknown'] as const;
export type ValidationStatusFilter = (typeof VALIDATION_STATUS_FILTERS)[number];

export const IMMUTABILITY_STATUS_FILTERS = ['Enabled', 'Disabled', 'N/A'] as const;
export type ImmutabilityStatusFilter = (typeof IMMUTABILITY_STATUS_FILTERS)[number];

export type LocationProfilesFiltersValues = z.infer<typeof locationProfilesFiltersSchema>;
export type LocationProfilesFiltersKeys = keyof LocationProfilesFiltersValues;

export type LocationProfilesQueryValues = z.infer<typeof locationProfilesRouteQuerySchema>;
export type LocationProfilesQueryKeys = keyof LocationProfilesQueryValues;

export const LOCATION_PROFILES_SORT_BY_KEYS = [
  'name',
  'status',
  'storageProvider',
  'target',
  'immutability',
] as const;
export type LocationProfileSortBy = (typeof LOCATION_PROFILES_SORT_BY_KEYS)[number];
